import script from "./WAuthorizationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./WAuthorizationForm.vue?vue&type=script&setup=true&lang=ts"

import "./WAuthorizationForm.vue?vue&type=style&index=0&id=4e0f0fbc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e0f0fbc"]])

export default __exports__